import apiClient from './apiClient'
import type { CustomerYaml } from '../types/customer'

const BASE = '/api/customers/yaml'

export const customerRegistryApi = {
  async list(): Promise<CustomerYaml[]> {
    const response = await apiClient.get<CustomerYaml[]>(BASE)
    return response.data
  },

  async get(profile: string): Promise<CustomerYaml> {
    const response = await apiClient.get<CustomerYaml>(`${BASE}/${encodeURIComponent(profile)}`)
    return response.data
  },

  async create(payload: CustomerYaml): Promise<CustomerYaml> {
    const response = await apiClient.post<CustomerYaml>(BASE, payload)
    return response.data
  },

  async update(profile: string, payload: CustomerYaml): Promise<CustomerYaml> {
    const response = await apiClient.put<CustomerYaml>(`${BASE}/${encodeURIComponent(profile)}`, payload)
    return response.data
  },

  async remove(profile: string): Promise<void> {
    await apiClient.delete(`${BASE}/${encodeURIComponent(profile)}`)
  },
}
